import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

export class ProjectLoader extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { projectId, version } = this.props.match.params;
    this.props.actions.loadDefaultPage({ projectId, version });
  }

  render() {
    const { match, location, editor } = this.props;
    const { projectId, version } = match.params;
    const { search } = location;
    const self = this;
    if (editor.defaultPage) {
      self.props.history.push(
        `/editor/${version}/v/${projectId}/pages/${editor.defaultPage.uuid}${search}`,
      );
    }
    return <div className="editor-project-loader">Loding default page...</div>;
  }
}

function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectLoader);
